export enum PortalRoles {
  Advisor = 'Advisor',
  Customer = 'Customer',
}
